import React from 'react';
import { LayoutGrid, Eye, Unlock, TrendingUp, AlertTriangle } from 'lucide-react';

interface Props {
  activeCount: number;
  totalListings: number;
  totalViews: number;
  totalUnlocks: number;
  revenueEstimate: number;
}

export default function OwnerStatCards({ activeCount, totalListings, totalViews, totalUnlocks, revenueEstimate }: Props) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
      {/* Hero: Active Listings */}
      <div className="sm:col-span-2 xl:col-span-1 bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl p-5 text-white shadow-card">
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm font-500 text-primary-100">الإعلانات النشطة</span>
          <div className="w-9 h-9 bg-white/20 rounded-xl flex items-center justify-center">
            <LayoutGrid size={18} className="text-white" />
          </div>
        </div>
        <div className="text-4xl font-800 tabular-nums mb-1">{activeCount}</div>
        <div className="text-xs text-primary-200">من أصل {totalListings} إعلان إجمالي</div>
      </div>

      {/* Total Views */}
      <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-card">
        <div className="flex items-center justify-between mb-3">
          <span className="text-xs font-600 text-gray-500 uppercase tracking-wide">إجمالي المشاهدات</span>
          <div className="w-8 h-8 bg-blue-50 rounded-xl flex items-center justify-center">
            <Eye size={16} className="text-blue-500" />
          </div>
        </div>
        <div className="text-3xl font-800 text-gray-900 tabular-nums mb-1">{totalViews.toLocaleString('ar-SA')}</div>
        <div className="flex items-center gap-1 text-xs text-emerald-600">
          <TrendingUp size={12} />
          +18% هذا الشهر
        </div>
      </div>

      {/* Total Unlocks */}
      <div className="bg-white rounded-2xl p-5 border border-gray-100 shadow-card">
        <div className="flex items-center justify-between mb-3">
          <span className="text-xs font-600 text-gray-500 uppercase tracking-wide">طلبات التواصل</span>
          <div className="w-8 h-8 bg-emerald-50 rounded-xl flex items-center justify-center">
            <Unlock size={16} className="text-emerald-500" />
          </div>
        </div>
        <div className="text-3xl font-800 text-gray-900 tabular-nums mb-1">{totalUnlocks}</div>
        <div className="text-xs text-gray-400">باحث كشف بيانات التواصل</div>
      </div>

      {/* Expired Alert */}
      <div className="bg-red-50 rounded-2xl p-5 border border-red-100 shadow-card">
        <div className="flex items-center justify-between mb-3">
          <span className="text-xs font-600 text-red-500 uppercase tracking-wide">تحتاج انتباهك</span>
          <div className="w-8 h-8 bg-red-100 rounded-xl flex items-center justify-center">
            <AlertTriangle size={16} className="text-red-500" />
          </div>
        </div>
        <div className="text-3xl font-800 text-red-700 tabular-nums mb-1">2</div>
        <div className="text-xs text-red-500">إعلان منتهي أو موقوف — فعّله الآن</div>
      </div>
    </div>
  );
}